import Common from "../../../../../Common";
import Account from "./queue/Account";

interface Body {
	ast_queue_id: id
}

const Queue = class extends Common {
	account: InstanceType<typeof Account>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.account = new Account(headers);
	}

	browse = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id
	) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue`)

	create = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		body: Body
	) =>
		this.post(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue`, body)

	delete = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		queueId: id
	) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/queue/${queueId}`)
}

export default Queue
